export default __webpack_public_path__ + "static/media/img-index-05-funcionalidades.095c7101.png";